import React, { Component } from 'react';
import { Grid, Typography, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import * as moment from 'moment';
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import InfoPopover from '../../Common/InfoPopover';



type Props = {
    deliveryTimeFrom: string | null,
    deliveryTimeTo: string | null,
    onChange: (deliveryDateFrom: string | null, deliveryDateTo: string | null) => void
}

type State = {
    selectedDay: string,
    dayOptions: { [id: string]: moment.Moment },
    selectedTimeFrom: moment.Moment | null,
    selectedTimeTo: moment.Moment | null
}

const DAY_UNSET: string = "Unset"

class DeliveryDeadline extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            selectedDay: '',
            dayOptions: this.getDayOptions(),
            selectedTimeFrom: null,
            selectedTimeTo: null,
        }
    }

    getDayOptions() {
        let days: { [id: string]: moment.Moment } = {}
        let today = moment.default()

        //Don't add same day, when order is placed
        for (let i = 0; i < 6; i++) {
            let next = moment.default(today.add('day', 1))
            days[next.format('dddd')] = next
        }
        return days
    }

    transferTime(date: moment.Moment, time: moment.Moment): string {
        let d = moment.default(date)
        d = d.hour(time.hours())
        d = d.minutes(time.minutes())
        return d.format()
    }

    internalOnChange = () => {
        let deliveryDateFrom: string | null = null
        let deliveryDateTo: string | null = null
        let date: moment.Moment | null = (this.state.selectedDay !== DAY_UNSET && this.state.selectedDay !== '') ? this.state.dayOptions[this.state.selectedDay] : null

        if (date !== null) {
            if (this.state.selectedTimeFrom !== null) {
                deliveryDateFrom = this.transferTime(date, this.state.selectedTimeFrom)
            }

            if (this.state.selectedTimeTo !== null) {
                deliveryDateTo = this.transferTime(date, this.state.selectedTimeTo)
            }
            else {
                let to = moment.default(date)
                to = to.hour(24)
                to = to.minutes(0)
                to = to.seconds(0)
                deliveryDateTo = to.format()
            }
        }

        this.props.onChange(deliveryDateFrom, deliveryDateTo)
    }

    render() {
        return (
            <Grid container style={{ marginBottom: '40px' }}>
                <Grid item xs={12}>
                    <Grid container alignItems="flex-end">
                        <Grid item xs={12} sm={3}>
                            <div style={{ display: 'inline-block' }}><Typography variant="h3">
                                <InfoPopover>
                                    If left unset supplier will set the delivery time.
                                </InfoPopover>
                                &nbsp;Delivery deadline&nbsp;
                            </Typography></div>
                        </Grid>
                        <Grid item xs={12} sm={9}>
                            <div style={{ display: 'inline-block', paddingLeft: '5px', paddingRight: '5px' }}>
                                <FormControl>
                                    <InputLabel>Day</InputLabel>
                                    <Select
                                        style={{ minWidth: '200px' }}
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={this.state.selectedDay}
                                        onChange={(e: any) => {
                                            if (e.target.value === DAY_UNSET)
                                                this.setState({ selectedDay: e.target.value, selectedTimeTo: null, selectedTimeFrom: null }, this.internalOnChange)
                                            else
                                                this.setState({ selectedDay: e.target.value }, this.internalOnChange)
                                        }}
                                    >
                                        <MenuItem value={DAY_UNSET}>{DAY_UNSET}</MenuItem>
                                        {Object.keys(this.state.dayOptions).map((d, i) => {
                                            return (<MenuItem key={i} value={d}>{this.state.dayOptions[d].format('dddd, Do MMM')}</MenuItem>)
                                        })}
                                    </Select>
                                </FormControl>
                            </div>

                            <div style={{ display: 'inline-block', paddingLeft: '5px', paddingRight: '5px' }}>
                                {/* <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <TimePicker
                                        autoOk
                                        label="Time from"
                                        value={this.state.selectedTimeFrom}
                                        onChange={(e: any) => this.setState({ selectedTimeFrom: e }, this.internalOnChange)}
                                    />
                                </MuiPickersUtilsProvider>
 */}
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <TimePicker
                                        autoOk
                                        disabled={this.state.selectedDay === DAY_UNSET || this.state.selectedDay === ''}
                                        label="Time"
                                        value={this.state.selectedTimeTo}
                                        onChange={(e: any) => this.setState({ selectedTimeTo: e }, this.internalOnChange)}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        );
    }
}

export default DeliveryDeadline;